/*=========================================================================================
  File Name: moduleEcommerceActions.js
  Description: Ecommerce Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "../../http/axios";

export default {


  login({commit}, dados) {
    return new Promise((resolve, reject) => {
      axios.post("auth/local", dados)
        .then((response) => {
          localStorage.setItem('integracaoLogged', JSON.stringify(response.data.user))
          // localStorage.setItem('accessToken', JSON.stringify(response.data.jwt))
          resolve(response);
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPaginas({commit}) {
    return new Promise((resolve, reject) => {
      axios.get("integracao-paginas")
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  storeDesempenho({commit}, dados) {
    return new Promise((resolve, reject) => {
      axios.post("integracao-desempenhos", dados)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  storefeedback({commit}, dados) {
    return new Promise((resolve, reject) => {
      axios.post("integracao-qualidades", dados)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

}
